"use client"

import { useActiveNav } from "@/lib/active-nav-context"
import { useEffect } from "react"

interface ActiveNavSetterProps {
   href: string
   category?: string | null
}

export function ActiveNavSetter({ href, category }: ActiveNavSetterProps) {
   const { setActiveNavHref, setActiveCategory } = useActiveNav()

   useEffect(() => {
      setActiveNavHref(href)
      setActiveCategory(category ?? null)

      return () => {
         setActiveNavHref(null)
         setActiveCategory(null)
      }
   }, [href, category, setActiveNavHref, setActiveCategory])

   return null
}
